module.exports = __webpack_public_path__ + "img/tarj2-3.b32eee6c.png";